import {
    Component,
    Input,
    OnInit,
    OnChanges,
    SimpleChanges,
    OnDestroy,
} from '@angular/core';
import { ChartType } from 'chart.js';
import { Color, Label, MultiDataSet } from 'ng2-charts';
import { Subscription } from 'rxjs';
import { EstadisticasService } from '../../../services/ofertas-laborales/estadisticas.service';

@Component({
    selector: 'app-doughnut-chart',
    templateUrl: './doughnut-chart.component.html',
    styleUrls: ['./doughnut-chart.component.scss'],
})
export class DoughnutChartComponent implements OnInit, OnChanges, OnDestroy {
    // === Estados reales ===
    @Input() cantPresentados: number = 0;
    @Input() cantDocumentosCargados: number = 0;
    @Input() cantEnRevision: number = 0;
    @Input() cantEnAuditoria: number = 0;
    @Input() cantEstadoAprobadas: number = 0;
    @Input() cantEstadoRechazadas: number = 0;

    public doughnutChartLabels: Label[] = [
        'Presentados',
        'Documentos cargados',
        'En revisión',
        'En auditoría médica',
        'Aprobadas',
        'Rechazadas',
    ];

    // Colores alineados con la UI (mismos hex base)
    public doughnutChartColors: Color[] = [
        {
            backgroundColor: [
                '#3b82f6', // Presentados
                '#9aa3af', // Docs
                '#f59e0b', // Revisión
                '#a78bfa', // Auditoría
                '#34d399', // Aprobadas
                '#f87171', // Rechazadas
            ],
            hoverBackgroundColor: [
                '#2563eb',
                '#6b7280',
                '#d97706',
                '#8b5cf6',
                '#10b981',
                '#ef4444',
            ],
            borderColor: '#ffffff',
            hoverBorderColor: '#ffffff',
            borderWidth: 2,
        },
    ];

    public doughnutChartData: MultiDataSet = [];
    public doughnutChartType: ChartType = 'doughnut';

    private refreshSub?: Subscription;

    constructor(private estadisticasService: EstadisticasService) {}

    ngOnInit(): void {
        this.cargarDataSet();
        // Si el padre avisa refresh, recargo dataset
        this.refreshSub = this.estadisticasService
            .refresh()
            .subscribe(() => this.cargarDataSet());
    }

    ngOnChanges(_: SimpleChanges): void {
        this.cargarDataSet();
    }

    ngOnDestroy(): void {
        this.refreshSub?.unsubscribe();
    }

    private cargarDataSet(): void {
        this.doughnutChartData = [
            [
                this.cantPresentados || 0,
                this.cantDocumentosCargados || 0,
                this.cantEnRevision || 0,
                this.cantEnAuditoria || 0,
                this.cantEstadoAprobadas || 0,
                this.cantEstadoRechazadas || 0,
            ],
        ];
    }
}
